import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=c0c83f42&"
import script from "./AddVendor.vue?vue&type=script&lang=js&"
export * from "./AddVendor.vue?vue&type=script&lang=js&"
import style0 from "./AddVendor.vue?vue&type=style&index=0&id=c0c83f42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports